import createContext from "../context";
export const [PopoverProvider, usePopoverProvider] = createContext('Popover');
//# sourceMappingURL=popover-context.js.map